namespace TabAurous.Common {
    export namespace TaxkHelperService {
        export const baseUrl = 'Common/TaxHelper';


        export declare const enum Methods {

        }

    }
}
